var map = {
	"./Droper.svg": 258,
	"./edit.svg": 211,
	"./icon-0.svg": 755,
	"./icon-1.svg": 404,
	"./icon-10.png": 976,
	"./icon-11.png": 977,
	"./icon-12.png": 978,
	"./icon-13.png": 979,
	"./icon-14.png": 980,
	"./icon-15.png": 981,
	"./icon-16.png": 982,
	"./icon-2.svg": 756,
	"./icon-3.svg": 757,
	"./icon-4.svg": 758,
	"./icon-5.png": 983,
	"./icon-6.png": 984,
	"./icon-7.png": 985,
	"./icon-8.png": 986,
	"./icon-9.png": 987,
	"./sort-active.svg": 137,
	"./sort.svg": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;